import React from 'react'; 
import './Footer.css';

const Footer = () => {
  return(
    <footer>
      <div className="rights">Copyright ® {new Date().getFullYear()} SALTO SYSTEMS S.L. All rights reserved</div>
      <div className="links">
        <a href="https://www.saltosystems.com/en/legal/legal-data/">Legal Data</a>
        <span className="separate"></span>
        <a href="https://www.saltosystems.com/en/legal/legal-data/cookies-policy/">Cookies Policy</a>
        <span className="separate"></span>
        <a href="https://www.saltosystems.com/en/legal/legal-data/privacy-policy/">Privacy Policy</a>
      </div>
    </footer>
  )
}

export default Footer;
